// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__dg2gA","title":"style__title__CSKuS","description":"style__description__M6AAk","component":"style__component__k76xP"};